import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const { baseURL, proName, payNameImg } = require("@/util/request.js");

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import './theme/index.css'
import './style/font/iconfont.css'
//处理element日期选择组件报错
function RepairProps(cmp) {
	(cmp.mixins || []).forEach(mixin => {
		if (mixin.props && mixin.props.placement) {
			const defaultValue = mixin.props.placement.default
			mixin.data = new Proxy(mixin.data, {
				apply(target, thisArg, argArray) {
					const res = Reflect.apply(target, thisArg, argArray)
					return {
						...(res || {}),
						placement: defaultValue
					}
				}
			})
			delete mixin.props.placement
		}
		if (mixin.mixins && mixin.mixins.length > 0) {
			RepairProps(mixin)
		}
	})
}

RepairProps(ElementUI.DatePicker)
RepairProps(ElementUI.TimePicker)
RepairProps(ElementUI.TimeSelect)

Vue.use(ElementUI)
Vue.prototype.$outTime = 24*60*60
import './style/index.scss' // global css
import local from './util/local'
Vue.prototype.$local = local
import util from './util/util'
Vue.prototype.$util = util
import api from '@/api/api'
Vue.prototype.$api = api
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.prototype.$baseURL = baseURL;
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import QRCode from 'qrcodejs2'
Vue.prototype.$QRCode = QRCode;

import vueI18n from 'vue-i18n'
Vue.use(vueI18n)
const locale = localStorage.getItem('lang')
const i18n = new vueI18n({
	locale: locale || 'zh',
	messages: {
		'zh': require('/src/assets/lang/zh.js'),
		'en': require('/src/assets/lang/en.js'),
	},

})

let hasSide = 'true'
Vue.prototype.$hasSide = hasSide
Vue.config.productionTip = false


Vue.prototype.$PayNameImg = payNameImg;

router.beforeEach((to, from, next) => {
	document.title = proName
	next()
})
new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
